import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Navbar as BSNavbar, Nav, Button, Container } from 'react-bootstrap';

function Navbar() {
    const { isAuthenticated, user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const isActive = (path) => location.pathname === path;

    return (
        <BSNavbar className="bc-navbar" expand="lg">
            <Container fluid="xl">
                <BSNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <img
                        src={"benfecalc.svg"}
                        height="48"
                        style={{ objectFit: 'contain' }}
                        alt="BenfeCalc"
                    />
                </BSNavbar.Brand>
                <BSNavbar.Toggle
                    aria-controls="bc-nav"
                    style={{ borderColor: 'rgba(255,255,255,0.3)', color: '#fff' }}
                />
                <BSNavbar.Collapse id="bc-nav">
                    <Nav className="me-auto ms-3">
                        {isAuthenticated && (
                            <>
                                <Nav.Link as={Link} to="/calculate"
                                    style={{ background: isActive('/calculate') ? 'rgba(255,255,255,0.14)' : '' }}>
                                    Edificações
                                </Nav.Link>
                                <Nav.Link as={Link} to="/lote"
                                    style={{ background: isActive('/lote') ? 'rgba(255,255,255,0.14)' : '' }}>
                                    Lote / Loteamento
                                </Nav.Link>
                                <Nav.Link as={Link} to="/history"
                                    style={{ background: isActive('/history') ? 'rgba(255,255,255,0.14)' : '' }}>
                                    Histórico
                                </Nav.Link>
                                <Nav.Link as={Link} to="/parametros"
                                    style={{ background: isActive('/parametros') ? 'rgba(255,255,255,0.14)' : '' }}>
                                    Parâmetros
                                </Nav.Link>
                            </>
                        )}
                    </Nav>
                    <Nav className="align-items-center gap-2">
                        {isAuthenticated ? (
                            <>
                                <span className="bc-username me-1">
                                    Olá, <strong>{user?.username}</strong>
                                </span>
                                <Button
                                    size="sm"
                                    onClick={handleLogout}
                                    style={{
                                        background: 'rgba(255,255,255,0.12)',
                                        border: '1px solid rgba(255,255,255,0.25)',
                                        color: '#fff',
                                        borderRadius: '6px',
                                        fontWeight: 500,
                                        fontSize: '0.82rem',
                                        padding: '0.35rem 0.875rem'
                                    }}
                                >
                                    Sair
                                </Button>
                            </>
                        ) : (
                            <Button variant="outline-light" size="sm" as={Link} to="/login"
                                style={{ borderRadius: '6px', fontWeight: 500, fontSize: '0.82rem' }}>
                                Entrar
                            </Button>
                        )}
                    </Nav>
                </BSNavbar.Collapse>
            </Container>
        </BSNavbar>
    );
}

export default Navbar;
